//* Libraries imports
import { useQuery } from "@tanstack/react-query";

//* Schemas Import
import { fullResult } from "../../../schemas/common/result/result";
import { createResponseFullSchema } from "../../../schemas/api-response";

//* Axios Import
import { privateApi } from "../../../services/apis/configs/apiClient";

//! Schema for the API response
const resultResponseSchema = createResponseFullSchema(fullResult);


/**
 * API para recurso
 */
const ResultAPI = {
  /**
   * Obtém um recurso específico pelo seu ID
   * @param id ID do recurso a ser recuperado
   * @returns Detalhes completos do recurso ou erro
   */
  getById: async function (id: number | undefined) {
    try {
      const response = await privateApi.get(
        `/student_portal/private/caderno-respostas/${id}`
      );


      // const validatedResponse = resultResponseSchema.parse(response);

      return {
        data: response.data.resultado,
        success: true,
      };
      
    } catch (error) {
      console.error(`Erro ao buscar recurso com ID ${id}:`, error);
      return {
        data: null,
        success: false,
        message:
          "Não foi possível carregar os detalhes do recurso. Tente novamente mais tarde.",
      };
    }
  },
};


/**
 * Hook para obter um resultado específico pelo ID
 * @param id ID do resultado a ser recuperado
 * @returns Query para detalhes completos do resultado
 */
export const useGetResult = (id: number | undefined) => {
  return useQuery({
    queryKey: ["resource-question", id],
    queryFn: async () => await ResultAPI.getById(id),
    retry: 2,
    staleTime: 1000 * 60 * 5,
    enabled: !!id,
  });
};
